import { memo } from 'react';
import styled from 'styled-components';

import Backdrop from './Backdrop';
import ScaleLoader from './ScaleLoader';

const HeadingTitle = styled.div`
  margin-top: 22px;
  font-size: 22px;
  font-weight: bold;
  text-align: center;
`;

type LoadingProps = {
  backdropStyle?: React.CSSProperties;
  open?: boolean;
  title?: string;
};

const Loading = memo(({ backdropStyle, open = true, title = '' }: LoadingProps) => {
  return (
    <Backdrop open={open} style={{ background: 'transparent', ...backdropStyle }}>
      <>
        <ScaleLoader />
        {title && <HeadingTitle>{title}</HeadingTitle>}
      </>
    </Backdrop>
  );
});

export const NoCardLoading = memo(({ open = true }: LoadingProps) => {
  return <ScaleLoader loading={open} height='30px' />;
});

export default Loading;
